module.exports = __webpack_public_path__ + "media/images/wealthbar/dashboard/gift-icon-f01e6132aae5bfd26981ca16e666853c.png";